/**
 * Servicio de estadísticas de token (panel "Stats"/"Rendimiento" de Asset Details)
 * Consume /api/proxy/token-stats — ver server/server.ts para el detalle de fuentes por campo.
 */

import { getApiBaseUrl } from '@/config/app';

export interface TokenStats {
  marketCap: number | null;
  volume24h: number | null;
  holders: number | null;
  createdAt: string | null;
  supplyAmount: number | null;
  securityRisk: 'none' | 'risk' | null;
  liquidityUSD: number | null;
  topHoldersPercent: number | null;
  performance: { m5: number | null; h1: number | null; h4: number | null; h24: number | null };
  totalVolume: number | null;
  transactions: number | null;
  buyPercent: number | null;
  sellPercent: number | null;
}

class TokenStatsService {
  async getTokenStats(network: string, symbol: string, address?: string): Promise<TokenStats | null> {
    try {
      const params = new URLSearchParams({ network, symbol });
      if (address) params.set('address', address);

      const res = await fetch(`${getApiBaseUrl()}/api/proxy/token-stats?${params.toString()}`);
      if (!res.ok) return null;

      const data = await res.json();
      return data.success ? (data.stats as TokenStats) : null;
    } catch (error) {
      console.error('[TokenStatsService] Error obteniendo estadísticas del token:', error);
      return null;
    }
  }
}

export const tokenStatsService = new TokenStatsService();
export default tokenStatsService;
